module.exports = __webpack_public_path__ + "img/126.11780cac.jpg";